import { Box, Typography } from '@mui/material'
import AppearanceSettingsContent from '@/components/Settings/AppearanceSettingsContent'
import GeneralSettingsContent from '@/components/Settings/GeneralSettingsContent'
import PlanUsageSettingsContent from '@/components/Settings/planUsage'
import shared from '@/components/Settings/settingsShared.module.scss'
import SettingsBillingSection from './SettingsBillingSection'
import SettingsConnectionsSection from './SettingsConnectionsSection'
import SettingsUsersSection from './SettingsUsersSection'

/**
 * @param {{ item: { id: string, label: string } }} props
 */
export default function SettingsPageContentBody({ item }) {
  return (
    <Box component="article" aria-labelledby="settings-page-title" className={shared.pageArticle}>
      <Typography
        id="settings-page-title"
        component="h1"
        variant="h5"
        fontWeight={600}
        color="text.primary"
        className={shared.pageTitle}
      >
        {item.label}
      </Typography>
      {item.id === 'plan-usage' ? <PlanUsageSettingsContent /> : null}
      {item.id === 'billing' ? <SettingsBillingSection /> : null}
      {item.id === 'users' ? <SettingsUsersSection /> : null}
      {item.id === 'connections' ? <SettingsConnectionsSection /> : null}
      {item.id === 'general' ? <GeneralSettingsContent /> : null}
      {item.id === 'appearance' ? <AppearanceSettingsContent /> : null}
    </Box>
  )
}
